import { ComponentProps, useState } from 'react';
import dayjs from 'dayjs';
import DatePopup from '~/components/Dashboard/components/DatePopup';
import { FilterChip } from '~/components/Dashboard/Monitoring/components/FilterSection/FilterChip';
import { UpdatedDateRange } from '~/components/Filters/@types';

export const UpdatedDateRangePicker = ({
  disabled,
  dateRange,
  onChange,
  size = 'medium',
}: {
  disabled?: boolean;
  dateRange: UpdatedDateRange;
  onChange: (value: UpdatedDateRange) => void;
  size?: ComponentProps<typeof FilterChip>['size'];
}) => {
  const [datePopupAnchorEl, setDatePopupAnchorEl] = useState<HTMLElement | null>(null);

  const handleDateRangeApply = ({ startDate, endDate }: UpdatedDateRange) => {
    setDatePopupAnchorEl(null);
    onChange({ startDate, endDate });
  };

  return (
    <div>
      <FilterChip
        isSelect
        size={size}
        label="Updated date"
        variant={dateRange.startDate && dateRange.endDate ? 'fill' : 'tint'}
        selected={parseToChipLabel(dateRange)}
        disabled={disabled}
        onClick={(event) => setDatePopupAnchorEl(event.currentTarget)}
      />
      {datePopupAnchorEl && (
        <DatePopup
          anchorEl={datePopupAnchorEl}
          data={dateRange}
          onApply={handleDateRangeApply}
          onClose={() => setDatePopupAnchorEl(null)}
        />
      )}
    </div>
  );
};
const parseToChipLabel = ({ startDate, endDate }: UpdatedDateRange) => {
  if (startDate && endDate) {
    if (startDate === endDate) {
      return { name: dayjs(startDate).format('MMM D, YYYY') };
    }
    return { name: `${dayjs(startDate).format('MMM D, YYYY')} ~ ${dayjs(endDate).format('MMM D, YYYY')}}` };
  }
};
